import {
  Flex,
  IconButton,
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
} from '@chakra-ui/react';
import {
  EmailShareButton,
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  TelegramShareButton,
} from 'react-share';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useAuthContext } from 'context/AuthProvider';
import { Share } from 'components/Icons';
import { CloseIcon } from '@chakra-ui/icons';

const ShareLevo = ({ open, onClose }: ShareLevoProps): JSX.Element => {
  const { user } = useAuthContext();

  const message =
    'I’ve been using Levo to improve the way I work and want you to join! Here is the link: ';

  const shareData = {
    title: 'Levo',
    subject: 'Levo',
    text: message,
    body: message,
    description: message,
    url: `https://levo-works.web.app/signup?referralCode=${user?.uid}`,
  };

  return (
    <Modal isOpen={open} onClose={onClose} size="4xl">
      <ModalOverlay />
      <ModalContent m="auto" bg="custom.levoOffWhite" borderRadius="8px">
        <Flex direction="column" width="100%" p={8}>
          <Flex direction="row" justifyContent="center" mb={6}>
            <Text textStyle="heading2" align="center">
              Share levo
            </Text>
            <IconButton
              position="absolute"
              top="20px"
              right="20px"
              variant="ghost"
              aria-label="Close share levo modal"
              icon={<CloseIcon boxSize="18px" />}
              onClick={() => onClose()}
            />
          </Flex>
          <Text
            textStyle="body"
            fontWeight="bold"
            color="custom.levoLightGray"
            align="center"
            mb={8}
          >
            Like Levo? Invite your friends to help them find great jobs!
          </Text>
          <Flex justifyContent="center" gridGap="32px" flexWrap="wrap" p={6}>
            <EmailShareButton {...shareData}>
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.EmailIcon boxSize={8} />
              </Flex>
            </EmailShareButton>
            <FacebookShareButton {...shareData}>
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.FacebookIcon boxSize={8} />
              </Flex>
            </FacebookShareButton>
            <WhatsappShareButton {...shareData}>
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.WhatsappIcon boxSize={8} />
              </Flex>
            </WhatsappShareButton>
            <TwitterShareButton {...shareData}>
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.TwitterIcon boxSize={8} />
              </Flex>
            </TwitterShareButton>
            <TelegramShareButton {...shareData}>
              <Flex
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.TelegramIcon boxSize={8} />
              </Flex>
            </TelegramShareButton>
            <CopyToClipboard
              text={`${shareData.text} ${shareData.url}`}
              onCopy={onClose}
            >
              <Flex
                cursor="pointer"
                direction="row"
                justifyContent="center"
                alignItems="center"
                bg="custom.levoWhite"
                borderRadius="100px"
                borderWidth="2px"
                borderColor="custom.levoDarkSnow"
                p={8}
              >
                <Share.LinkIcon boxSize={8} />
              </Flex>
            </CopyToClipboard>
          </Flex>
        </Flex>
      </ModalContent>
    </Modal>
  );
};

export default ShareLevo;
